module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/439cddb83c09b2be056ed9587a26ccf6.png";